
const experienceList = [
    {
      jobTitle: "Software Developer",
      jobTime: "April 2025 - Now",
      jobCompany: "OMERS",
      jobDescription: [
        `Engineered automated data pipelines and SQL-driven workflows to aggregate cross-business-unit communication data and generate KPI-driven analytics dashboards for executive stakeholders. `,
        `Supported and operated large-scale communication, ensuring reliable and timely delivery of communication to 500,000+ recipients with a strong focus on stability and accuracy.`
      ],
      tags: [
        "Next.js",
        "Microsoft Azure",
        "SQL",
        "NodeJs",
        "MeanStak",
        "TypeScript",
        "Gitlab",
        "Salesforce Marketing Cloud",
        "Analytics tool"
      ],
    },
    {
      jobTitle: "Software Developer",
      jobTime: "May 2023 - March 2025",
      jobCompany: "Lantern Capital",
      jobDescription: [
        `Led the team for ETL pipeline development by spearheading the planning, execution 
          implementation and backup strategy for a user web application.`,
        `Worked in Agile Environment, Managed Azure resources, GitHub repositories, and weekly retrospectives for
              sprint evaluations, with full responsibility for these areas.`,
      ],
      tags: [
        "MERN Stack",
        "AZURE DevOps",
        "Github Actions",
        "NodeJs",
        "JavaScript",
        "TypeScript",
        "GraphQL",
        "Python",
        "PowerShell",
        "Dynamics CRM",
        "SQL",
        "PowerApps",
        "PowerAutomate",
      ],
    },
    {
      jobTitle: "Software Engineer",
      jobTime: "Feb 2021 - Feb 2022",
      jobCompany: "Shyena Tech Yarns",
      jobDescription: [
        `Modernized search component with elastic search on Django REST Framework in Python with Postgres
  database which increased search time efficiency by 60%.`,
        `Designed lambda function with python to calculate accurate location by using ArcGIS, Google Map API and
  custom Addresses database resulting in 65% location determination accuracy.`,
      ],
      tags: [
        "MERN Stack",
        "AWS DevOps",
        "Python",
        "Django REST Framework",
        "MongoDB",
        "Postgres",
        "Elastic Search",
        "RabbitMQ",
      ],
    },
    // {
    //   jobTitle: "Java Developer",
    //   jobTime: "Jul 2019 - Sep 2019",
    //   jobCompany: "The Sparks Foundation · Internship",
    //   jobDescription: [
    //     `Created a web application with Java EE as part of a interview assignment highlighting using web components such as JSP, Java Servlet etc.`,
    //     `Developed a REST API with Java Spring Boot, JPA, and Hibernate to perform various curd operations.`,
    //   ],
    //   tags: [
    //     "Java",
    //     "SpringBoot",
    //     "Hybernate",
    //     "JavaEE",
    //     "Apache",
    //     "SQL Server"
    //   ],
    // }
  ];

const eductionList = [
  {
    degreeName: "Post Graduate Diploma",
    programName: "Computer Software and Database Management",
    date: "Jan 2022 - Aug 2023",
    institutionName: "Lambton College",
    description: [
      `Worked on Multiple Projects with using tech stacks like JavaEE, SpringBoot, Flask, MERN, Django`,
      `Designed and implemented Credit Management Database with PlSQL, to manage User, Credits, and added multiple procedures
        to ease calculations of usage and analysis of credit per user.  `,
    ],
    tags: [
      "Java",
      "Python",
      "JavaScript",
      "NodeJS",
      "ReactJS",  
      "AWS",
      "SQL",
      "PLSQL",
      "MongoDB",
      "SpringBoot",
      "JavaEE",
      "Oracle DB",
    ],
  },
  {
    degreeName: "Bachelor of Engineering",
    programName: "Information Technology",
    date: "Aug 2016 - Aug 2020",
    institutionName: "Gujarat Technological University",
    description: [
      `Build web portal for Chat Application with JavaEE, worked with Firebase database, implemented OAuth for authentication 
        and designed frontend using JSP, BootStrap etc.`,
      `Worked with Deep Learning NLP model to design a chatbot to act as a Companion to a human.`,
    ],
    tags: [
      "Java",
      "C++",
      "Python",
      "JavaScript",
      "C#",
      "HTML5",  
      "CSS",
      "Bootstrap",
      "NodeJS",
      "SQL",
      "Java SpringBoot",
      "Machine Learning",
      "JavaEE",
      "Oracle DB",
    ],
  }
]

export { experienceList, eductionList };
